import React from "react";
import { PaymentAlertActionProps, PaymentAlertProps } from "@swiggy-private/payment-types";

export interface PaymentAlertConfig extends Omit<PaymentAlertProps, "primaryAction"> {
    primaryAction: Omit<PaymentAlertActionProps, "text">;
}

export const DEFAULT_PAYMENT_ALERT_PROPS: PaymentAlertConfig = {
    hideCloseIcon: true,
    hideOnOverlayClick: false,
    primaryAction: { onClick: () => void 0 },
};

export const GenericPaymentAlertContext = React.createContext<PaymentAlertConfig>(DEFAULT_PAYMENT_ALERT_PROPS);

if (__DEV__) {
    GenericPaymentAlertContext.displayName = "GenericPaymentAlertContext";
}
